import { useMemo, useState } from "react";
import { movieCategories, movies } from "@/mocks/home";

export default function Showcase() {
  const [active, setActive] = useState("全部");

  const visible = useMemo(
    () => (active === "全部" ? movies : movies.filter((m) => m.category === active)),
    [active],
  );

  return (
    <section id="catalog" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
              <i className="ri-fire-line"></i>
              热门片库
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              按类型浏览，找到今晚想看的
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              片库覆盖电影、剧集、动漫、综艺与纪录片。切换下面的类型标签即可在本页筛选，
              每部作品都标注了题材、年份与评分，方便快速判断。
            </p>
          </div>

          <div className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-50 border border-background-200 self-start lg:self-auto">
            {movieCategories.map((cat) => {
              const isActive = cat === active;
              return (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setActive(cat)}
                  aria-pressed={isActive}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50 dark:text-foreground-950 font-medium"
                      : "text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {cat}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {visible.map((m) => (
            <article
              key={m.id}
              className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
                <img
                  src={m.poster}
                  alt={`${m.title} 影视海报`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-background-50/90 text-foreground-800">
                  {m.category}
                </span>
                <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold bg-accent-500 text-background-50 dark:text-foreground-950">
                  <i className="ri-star-fill"></i>
                  {m.rating}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  {m.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {m.desc}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {m.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400">{m.year}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs md:text-sm text-foreground-500">
          当前类型共 {visible.length} 部作品，切换标签可查看其他内容。
        </p>
      </div>
    </section>
  );
}